import { render, staticRenderFns } from "./recebimento.vue?vue&type=template&id=03bb02ba&scoped=true"
import script from "./recebimento.vue?vue&type=script&lang=ts"
export * from "./recebimento.vue?vue&type=script&lang=ts"
import style0 from "./recebimento.vue?vue&type=style&index=0&id=03bb02ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb02ba",
  null
  
)

export default component.exports